import { containsSpecialCharacters, containsSpecialCharactersLocation } from '../../lib/extensions/StringExtensions'

export default function validateNewListingForm(listing) {
    const {
        listingType,
        CategoryID,
        SubCategoryID,
        CustomerNumber,
        Prefix,
        FirstName,
        LastName,
        OrganizationName,
        OwnerName,
        Address1,
        Address2,
        City,
        StateProvince,
        ZipCode,
        CountryID,
        LocationDescription,
        FarmMessage,
        logo,
        CowCount,
        WebsiteUrl,
        FacebookUrl,
        LinkedInUrl,
        YoutubeUrl,
        InstagramUrl,
        fileName,
    } = listing;

    const errors = {
        listingType: '',
        CategoryID: '',
        CustomerNumber: '',
        Prefix: '',
        FirstName: '',
        LastName: '',
        OrganizationName: '',
        OwnerName: '',
        Address1: '',
        Address2: '',
        City: '',
        StateProvince: '',
        ZipCode: '',
        CountryID: '',
        LocationDescription: '',
        FarmMessage: '',
        logo: '',
        CowCount: '',
        WebsiteUrl: '',
        FacebookUrl: '',
        LinkedInUrl: '',
        YoutubeUrl: '',
        InstagramUrl: '',
        Picture: '',
    };

    // Perform likewise validations
    errors.CategoryID = validateCategory(CategoryID);
    errors.CustomerNumber = validateCustomerNumber(CustomerNumber);
    errors.Prefix = validatePrefix(Prefix);
    errors.Address1 = validateAddress1(Address1);
    errors.Address2 = validateAddress2(Address2);
    errors.City = validateCity(City);
    errors.StateProvince = validateState(StateProvince);
    errors.ZipCode = validateZipCode(ZipCode);
    errors.CountryID = validateCountry(CountryID);
    errors.LocationDescription = validateLocationDescription(LocationDescription);
    errors.FarmMessage = validateFarmMessage(FarmMessage);
    errors.CowCount = validateCowCount(CowCount);
    errors.WebsiteUrl = validateWebsiteUrl(WebsiteUrl);
    errors.FacebookUrl = validateFacebookUrl(FacebookUrl);
    errors.LinkedInUrl = validateLinkedInUrl(LinkedInUrl);
    errors.YoutubeUrl = validateYoutubeUrl(YoutubeUrl);
    errors.InstagramUrl = validateInstagramUrl(InstagramUrl);
    errors.Picture = validatePicture(fileName);

    /* Validate all the individual type listing information */
    if (listingType == '2', '5', '6') {
        if (listingType == '1' && SubCategoryID == '2') {
            errors.FirstName = validateFirstName(FirstName);
            errors.LastName = validateLastName(LastName);
        }
    }
    else // Validate all the organization type listing information
    {
        errors.OrganizationName = validateOrganizationName(OrganizationName);
        errors.OwnerName = validateOwners(OwnerName);
    }

    return errors;
}

/* Validates the Category data provided in the new listing */
function validateCategory(CategoryID) {
    var result = '';

    if (CategoryID == null) {
        result = '* Category is required'
    }

    return result;
}

/* Validates the customer number data provided in the new listing */
function validateCustomerNumber(CustomerNumber) {
    var result = '';

    if (CustomerNumber == null) {
        result = '* AJCA customer number is required';
    }
    else if (CustomerNumber.length > 7) {
        result = '* AJCA customer number has exceeded maximum length'
    }
    else if (isNaN(CustomerNumber)) {
        result = '* AJCA customer number can only consist of numerical values'
    }

    return result;
}

/* Validates the customer prefix data provided in the new listing */
function validatePrefix(Prefix) {
    var result = '';
    if (Prefix != null) {
        if (Prefix.length > 20) {
            result = '* Prefix cannot exceed 20 characters'
        }
        else if (containsSpecialCharacters(Prefix)) {
            result = '* Prefix cannot contain special characters'
        }
    }

    return result;
}

/* Validates the first name data provided in the new listing */
function validateFirstName(FirstName) {
    var result = '';
    if (FirstName != null) {
        if (FirstName.trim() == '') {
            result = '* First name is required';
        }
        else if (FirstName.length > 50) {
            result = '* First name has exceeded maximum length'
        }
        else if (containsSpecialCharacters(FirstName)) {
            result = '* First name cannot contain special characters'
        }
    }

    return result;
}

/* Validates the last name data provided in the new listing */
function validateLastName(LastName) {
    var result = '';
    if (LastName != null) {
        if (LastName.trim() == '') {
            result = '* Last name is required';
        }
        else if (LastName.length > 50) {
            result = '* Last name has exceeded maximum length';
        }
        else if (containsSpecialCharacters(LastName)) {
            result = '* Last name cannot contain special characters'
        }
    }

    return result;
}

/* Validates the organization name data provided in the new listing */
function validateOrganizationName(OrganizationName) {
    var result = '';

    if (OrganizationName == null || OrganizationName.trim() == '') {
        result = '* Organization name is required';
    }
    else if (OrganizationName.length > 150) {
        result = '* Organization name has exceeded maximum length';
    }
    else if (containsSpecialCharacters(OrganizationName)) {
        result = '* Organization name cannot contain special characters';
    }

    return result;
}

/* Validates the owners data provided in the new listing */
function validateOwners(OwnerName) {
    var result = '';
    if (OwnerName != null || OwnerName.trim() == '') {
        if (OwnerName.length > 100) {
            result = '* Owner has exceeded maximum length'
        }
    }

    return result;
}

/* Validates the address 1 data provided in the new listing */
function validateAddress1(Address1) {
    var result = '';

    if (Address1 == null) {
        result = '* Address 1 is required'
    }
    else if (Address1.length > 50) {
        result = '* Address 1 cannot exceed 50 characters'
    }
    else if (containsSpecialCharacters(Address1)) {
        result = '* Address 1 cannot contain special characters'
    }

    return result;
}

/* Validates the address 2 data provided in the new listing */
function validateAddress2(Address2) {
    var result = '';
    if (Address2 != null) {
        if (Address2.length > 50) {
            result = '* Address 2 cannot exceed 50 characters'
        }
        else if (containsSpecialCharacters(Address2)) {
            result = '* Address 2 cannot contain special characters'
        }

    }

    return result;
}

/* Validates the city data provided in the new listing */
function validateCity(City) {
    var result = '';

    if (City == null || City.trim() == '') {
        result = '* City is required'
    }
    else if (City.length > 30) {
        result = '* City cannot exceed 30 characters'
    }
    else if (containsSpecialCharacters(City)) {
        result = '* City cannot contain special characters'
    }

    return result;
}

/* Validates the state data provided in the new listing */
function validateState(StateProvince) {
    var result = '';

    if (StateProvince == null) {
        result = '* State is required'
    }

    return result;
}

/* Validates the zip code data provided in the new listing */
function validateZipCode(ZipCode) {
    var result = '';

    if (ZipCode == null) {
        result = '* Zip Code is required'
    }
    else if (ZipCode.length > 20) {
        result = '* Zip code cannot exceed 20 characters'
    }
    else if (containsSpecialCharacters(ZipCode)) {
        result = '* Zip code cannot contain special characters'
    }

    return result;
}

/* Validates the country code data provided in the new listing */
function validateCountry(CountryID) {
    var result = '';

    if (CountryID == null) {
        result = '* Country is required'
    }

    return result;
}

/* Validates the location description provided in the new listing */
function validateLocationDescription(LocationDescription) {
    var result = '';

    if (LocationDescription != null) {
        if (LocationDescription.length > 8000) {
            result = '* Location description has exceeded maximum length'
        }
        else if (containsSpecialCharactersLocation(LocationDescription)) {
            result = '* Location description cannot contain special characters'
        }
    }
    return result;
}

/* Validates the farm message provided in the new listing */
function validateFarmMessage(FarmMessage) {
    var result = '';
    if (FarmMessage != null) {
        if (FarmMessage.length > 8000) {
            result = '* Farm message has exceeded maximum length';
        }
    }

    return result;
}

/* Validates the cow count provided in the new listing */
function validateCowCount(CowCount) {
    var result = '';

    if (CowCount != null) {
        if (isNaN(CowCount)) {
            result = '* Cow count must be a numerical value';
        }
        else if (CowCount <= 0) {
            result = '* Cow count must be greater than 0'
        }
    }

    return result;
}

/* Validates the website URL data provided in the new listing */
function validateWebsiteUrl(WebsiteUrl) {
    var result = '';

    if (WebsiteUrl != null && WebsiteUrl.trim() != '') {
        if (WebsiteUrl.length > 255) {
            result = '* Website URL has exceeded maximum length'
        }
    }

    return result;
}

/* Validates the facebook URL data provided in the new listing */
function validateFacebookUrl(FacebookUrl) {
    var result = '';

    if (FacebookUrl != null && FacebookUrl.trim() != '') {
        if (FacebookUrl.length > 255) {
            result = '* Facebook URL has exceeded maximum length'
        }
    }

    return result;
}

/* Validates the linkedIn URL data provided in the new listing */
function validateLinkedInUrl(LinkedInUrl) {
    var result = '';

    if (LinkedInUrl != null && LinkedInUrl.trim() != '') {
        if (LinkedInUrl.length > 255) {
            result = '* LinkedIn URL has exceeded maximum length';
        }
    }

    return result;
}

/* Validates the youtube URL data provided in the new listing */
function validateYoutubeUrl(YoutubeUrl) {
    var result = '';

    if (YoutubeUrl != null && YoutubeUrl != '') {
        if (YoutubeUrl.length > 255) {
            result = '* Instagram URL has exceeded maximum length'
        }
    }

    return result;
}

/* Validates the instagram URL data provided in the new listing */
function validateInstagramUrl(InstagramUrl) {
    var result = '';

    if (InstagramUrl != null && InstagramUrl != '') {
        if (InstagramUrl.length > 255) {
            result = '* Instagram URL has exceeded maximum length'
        }
    }

    return result;
}

/* Vaildates the Picture File provided in the listing */
function validatePicture(fileName) {
    var result = '';
    var allowedExtensions = /(\.jpg|\.jpeg)$/i;

    if (fileName != null) {
        if (!allowedExtensions.exec(fileName)) {
            result = 'Invalid file type. Please upload a file with .jpg or .jpeg extension.';
        }
    }

    return result;
}